Vue.component('factionleaderboard', {
    template: templates.factionLeaderBoard,
    data() {
      return {
        model: {
          users: [],
          top: [],
          medals: [],
          isLoggedIn: false,
        }
      }
    },
    mounted() {
      const c = this;
      c.get();
    },
    methods: {
      async get() {
        const c = this;
    
        try {
            const factionResponse = await factionService.getUserFaction();
       
    
            if (factionResponse.data.length === 1) {
                c.model.factionName = factionResponse.data[0].name;
                c.model.id = factionResponse.data[0].id;
    
                try {
                    const leaderboardResponse = await userService.getLeaderboardFaction(factionResponse.data[0].id);
                    c.model.users = leaderboardResponse.data;
    
                    // Filter out users with null user property
                    c.model.users = c.model.users.filter(user => user.user !== null);
    
                    // Continue with the rest of your logic...
                    const updatedUsers = [];
    
                    const userPromises = c.model.users.map((userEntry) => {
                        return new Promise((resolve) => {
                            c.getCurrentTwitchInfo(userEntry.user[0].twitchId, function(user) {
                                if (user) {
                                    // Update user with Twitch info and keep user
                                    userEntry.user[0] = {
                                        twitchId: user.twitchId,
                                        twitchDisplayName: user.twitchDisplayName,
                                        twitchProfileImage: user.twitchProfileImage
                                    };
                                    updatedUsers.push(userEntry);
                                }
                                resolve();
                            });
                        });
                    });
    
                    await Promise.all(userPromises);
    
                    // Replace the original users array with filtered and updated users
                    c.model.users = updatedUsers;
    
                    // Set the top users based on filtered list
                    if (c.model.users.length >= 3) {
                        const [first, second, third] = c.model.users;
                        c.model.top = [second, first, third];
                    } else {
                        c.model.top = [...c.model.users];
                    }
                    c.model.isLoggedIn = true;
    
                } catch (error) {
                    c.model.isLoggedIn = false; // Keep the user logged in even if there's an error
                    console.log('Error fetching leaderboard faction:', error);
                }
            }
        } catch (error) {
            return;
        }
    },    
      getTwitchInfo(data) {
        const c = this;
  
        const twitchIds = data.map(item => ({ twitchId: item.twitchId }));
  
  
        twitchAPI.getUsersById(twitchIds, function(userData) {
          for (let d of userData) {
    
            let user = {
              twitchId: d.id,
              twitchDisplayName: d.display_name,
              twitchProfileImage: d.profile_image_url
            }


            const match = data.find(item => item.twitchId === user.twitchId);
            c.model.users.push(match)
            if (match) {
              // Step 5: Update the matched entry with user information
              // match.twitchDisplayName = user.twitchDisplayName;
              // match.twitchProfileImage = user.twitchProfileImage;
              match.twitchDisplayName = user.twitchDisplayName;
              match.twitchProfileImage = user.twitchProfileImage;
            } 
  
          }
        });
        
      },
      getCurrentTwitchInfo(data, callback) {
        const c = this;
        twitchAPI.getUsersById([{ twitchId: data }], function(userData) {
          if (userData && userData.length > 0) {
            let user = {
              twitchId: userData[0].id,
              twitchDisplayName: userData[0].display_name,
              twitchProfileImage: userData[0].profile_image_url
            };
            callback(user); // Call the callback with the user data
          } else {
            callback(null); // Call the callback with null if no user data is found
          }
        });
      },
  
    
    
    }
  });